import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { IClientJob } from 'src/modules/company-dashboard/interfaces/client-job.interface';
import { ShiftValidatorService } from 'src/modules/company-dashboard/services/shift-validator.service';
import { JobService } from '../../services/job.service';
import { LoadingService } from '../../services/loading.service';
import { PopupService } from '../../services/popup.service';
import { UtilService } from '../../services/util.services';

@Component({
  selector: 'app-edit-recurrent-specific-shifts',
  templateUrl: './edit-recurrent-specific-shifts.component.html',
  styleUrls: ['./edit-recurrent-specific-shifts.component.scss'],
})
export class EditRecurrentSpecificShiftsComponent implements OnInit, OnChanges {


  editRecurrentSpecificShiftForm: FormGroup;
  recurringShiftsCollection;
  @Input() jobItem: IClientJob
  @Input() timeZone: string;
  @Input() interfaceCssClass: string = '';
  @Input() submitView
  confirmationView: Boolean = false;
  skipItems = 5;
  data = []

  config = ["Date", "Start Time", "End Time", "Unpaid Break", "Transit Allowance","Action"]
  shifts = []
  selectedShifts: { [key: string]: boolean } = {};

  constructor(
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private jobService: JobService,
    private popupService: PopupService,
    private shiftValidatorService: ShiftValidatorService,
    private changeDetectorRef: ChangeDetectorRef,
    private utilService: UtilService
  ) { }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  ngOnChanges(change) {
    if(change.submitView && change.submitView.currentValue){
      this.config = ["Date", "Start Time", "End Time", "Unpaid Break", "Transit Allowance"]
    }
  }

  ngOnInit() {
    this.createForm();


    this.shifts = this.jobItem.jobs.map((item, index) =>
    ({
      Date: moment(item.shiftDate).tz(item.timeZone).format('DD MMM,YY'),
      'Start Time': moment(item.shiftStartTime, 'X').tz(item.timeZone).format('hh:mm A'),
      'End Time': moment(item.shiftEndTime, 'X').tz(item.timeZone).format('hh:mm A'),
      'Unpaid Break': item.break ? item.break.unpaid : "No break",
      'Transit Allowance': this.utilService.formatTransitAllowance(item.travelTime),
      _id: item._id,
      index
    }))
    if (this.shifts.length > this.skipItems ) {
      this.data = this.shifts.slice(0, this.skipItems)
    } else {
      this.data = this.shifts;
    }

  }

  async loadMoreData() {
    const loader = await this.loadingService.showLoading().toPromise();

    setTimeout(() => {
      this.data = [...this.shifts.slice(0, this.skipItems + 5)]
      this.skipItems += 5;
      this.loadingService.hideLoading(loader);
    }, 2000)


  }

  createForm() {
    this.recurringShiftsCollection = [];
    for (let i = 0; i < this.jobItem.jobs.length; i++) {
      this.recurringShiftsCollection.push(this.formBuilder.group({
        date: [moment(this.jobItem.jobs[i].shiftDate).tz(this.timeZone).format('DD MMM,YY'), [Validators.required]],
        _id: [this.jobItem.jobs[i]._id],
        startTime: [{ value: this.jobItem.jobs[i].shiftStartTime, formatted: moment(this.jobItem.jobs[i].shiftStartTime, 'X').tz(this.timeZone).format('hh:mm A') }, [Validators.required, this.shiftValidatorService.validateTime('startTime')]],
        endTime: [{ value: this.jobItem.jobs[i].shiftEndTime, formatted: moment(this.jobItem.jobs[i].shiftEndTime, 'X').tz(this.timeZone).format('hh:mm A') }, [Validators.required, this.shiftValidatorService.validateTime('endTime')]],
        unpaidBreak: [{ label: this.jobItem.jobs[i].break ? this.jobItem.jobs[i].break.unpaid : "No Break", value: this.jobItem.jobs[i].break ? this.jobItem.jobs[i].break.unpaid : "No break" }],
        transitAllowance: [{ 
          label: this.jobItem.jobs[i].travelTime ? 
            this.utilService.formatTransitAllowance(this.jobItem.jobs[i].travelTime) : 
            "None", 
          value: this.jobItem.jobs[i].travelTime ? this.jobItem.jobs[i].travelTime.toString() : "0", 
        }],
        selected: [false]
      })
      );
    }

    this.editRecurrentSpecificShiftForm = this.formBuilder.group({
      recurringShifts: this.formBuilder.array(this.recurringShiftsCollection)
    })

  }

  trackShiftPropertyChanges(updateView: Boolean = false) {
    let updatedData = [];
    let data = [];

    for (const item of this.shifts) {
      const shift = this.editRecurrentSpecificShiftForm.value.recurringShifts.find(obj => obj._id == item._id);

      if (!shift) {
        continue;
      }

      if (item["Date"] !== shift.date
        || item["Start Time"] !== shift.startTime.formatted
        || item["End Time"] !== shift.endTime.formatted
        || item["Unpaid Break"] !== shift.unpaidBreak.value
        || item["Transit Allowance"] !== shift.transitAllowance.value
        || this.selectedShifts[shift._id]) {

        updatedData.push({
          shiftDate: shift.date,
          _id: shift._id,
          shiftStartTime: shift.startTime.value,
          shiftEndTime: shift.endTime.value,
          unpaidBreak: shift.unpaidBreak.value,
          transitAllowance: shift.transitAllowance.value,
        })
        data.push(item)
      }
    }

    if (updateView) {
      this.data = data;
      // this.shifts = this.data;
    }
    return updatedData;
  }

  async onSubmit(cb) {
    this.editRecurrentSpecificShiftForm.markAllAsTouched();

    if (this.editRecurrentSpecificShiftForm.valid) {
      const loader = await this.loadingService.showLoading().toPromise();
      try {
        if (Object.keys(this.selectedShifts).length > 0) {
          await this.jobService.deleteRecurrShift(this.jobItem.recurringShift.groupJobId, 'specific', {
            specificJobs: this.selectedShifts,

          });
        }
        const recurrentTempId = this.jobItem.recurringShift.groupShift.recurrentShiftTemplateId?.[0] ?? undefined;

        if (Object.keys(this.selectedShifts).length === this.shifts.length && recurrentTempId) {
          await this.jobService.deleteRecurrentShiftTemplate(recurrentTempId._id)
        } else {
          await this.jobService.editRecurrentSpecificShifts(this.jobItem.recurringShift.groupJobId, { jobs: this.trackShiftPropertyChanges() });
        }

        this.loadingService.hideLoading(loader);
        this.popupService.showModal({
          heading: 'Success',
          message: Object.keys(this.selectedShifts).length === 0 ? 'You have successfully edited the recurring shifts.' : 'You have successfully edited and deleted the recurring shifts.',
          btn: 'Dismiss',
          navigateRoute: '',
          imgURL: 'assets/images/request-sent.png'
        }, async (data) => {
        if(cb){
          await cb()
        }
        });

      }
      catch (error) {
        this.loadingService.hideLoading(loader);
        this.popupService.showModal({
          heading: 'Error',
          message: error.error || 'Something went wrong. Please try again.',
          btn: 'Dismiss!',
          navigateRoute: '',
          imgURL: 'assets/images/sorry1.png'
        });
      }
    }
    return true;
  }


  /**
   * 
   * If a single checkbox is toggles
   */
  onToggleCheckBox({ index }: { index: number }) {
    const shiftId = this.shifts[index]._id;
    if (!this.selectedShifts[shiftId]) {
      this.selectedShifts[shiftId] = true;
    } else {
      delete this.selectedShifts[shiftId]
    }
  }

  getSelectedShiftCount(){
    return Object.keys(this.selectedShifts).length
  }

  /**
   * 
   * If parent checkbox is toggled
   */

  onToggleAllCheckBoxes({ checked, index }: { checked: boolean; index: number }) {
    for (let i = index; i < this.data.length; i++) {
      this.editRecurrentSpecificShiftForm.get("recurringShifts")['controls'][i].get("selected").setValue(checked);
      const shiftId = this.data[i]._id;
      if (!this.selectedShifts[shiftId] && checked) {
        this.selectedShifts[shiftId] = true;
      } else if (this.selectedShifts[shiftId] && !checked) {
        delete this.selectedShifts[shiftId];
      }
    }

    this.editRecurrentSpecificShiftForm.updateValueAndValidity();

  

  }
}
